/* eslint-disable no-unused-vars */
import { DMCObject } from "./DMCObject";
import { Scrolling } from "../EditTools/ScrollingTool";
import Konva from "konva";

// PUT THE TEXT IN THIS OBJECT !
export class DMCScrolling extends DMCObject {
  constructor(name, konvaObject, dataScrolling) {
    super(name, konvaObject);
    this.dataScrolling = dataScrolling;
    this.anim = new Konva.Animation({});
    this.anim2 = new Konva.Animation({});
  }

  copyOption(DMCObject) {
    let newOption = {};
    newOption.x = DMCObject.konvaObjectOption.x;
    newOption.y = DMCObject.konvaObjectOption.y;
    newOption.width = DMCObject.konvaObjectOption.width;
    newOption.height = DMCObject.konvaObjectOption.height;
    newOption.scaleX = DMCObject.konvaObjectOption.scaleX;
    newOption.scaleY = DMCObject.konvaObjectOption.scaleY;
    newOption.name = DMCObject.konvaObjectOption.name;
    newOption.id = DMCObject.konvaObjectOption.id;
    newOption.draggable = true;

    return newOption;
  }

  createNewObject(DMCObject) {
    return;
  }

  getType() {
    return "Scrolling";
  }

  load(controllerProject, DMCObject, incorporate) {
    let scrollingTool = new Scrolling();

    this.anim = new Konva.Animation(DMCObject.anim);
    this.anim2 = new Konva.Animation(DMCObject.anim2);
    this.name = DMCObject.name;
    DMCObject.konvaObjectOption = this.copyOption(DMCObject, controllerProject);
    this.dataScrolling = DMCObject.dataScrolling;
    scrollingTool.scrolling(DMCObject.dataScrolling);
    this.konvaObject = scrollingTool.loadSpec(controllerProject, DMCObject, incorporate);
    this.konvaObjectOption = this.konvaObject.attrs;

    this.loadEnd(DMCObject);
    return this;
  }

  loadEnd(obj) {
    try {
      let properties = obj.konvaObject;

      if (typeof properties !== "object") {
        properties = JSON.parse(obj.konvaObject);
      }

      const color = properties.children[1].attrs["fill"];
      const font = properties.children[1].attrs["fontFamily"];
      // Restore properties
      this.setColor(color);
      this.setFont(font);
    } catch (err) {
      console.error("Error reading scroll properties:", err);
    }
    return obj;
  }

  select() {
    this.creationAnimation(this.konvaObject);
  }

  stopPreview() {
    this.deselect();
  }

  delete() {
    this.deselect();
  }

  deselect() {
    this.anim.stop();
    this.anim2.stop();
    if (this.konvaObject.children.length > 0) {
      if (this.dataScrolling.axe) {
        if (!this.dataScrolling.sens) {
          this.konvaObject.children[1].x(this.konvaObject.attrs.width - this.konvaObject.children[1].size().width);
          this.konvaObject.children[2].x(this.konvaObject.attrs.width - this.konvaObject.children[2].size().width);
        } else {
          this.konvaObject.children[1].x(0);
          this.konvaObject.children[2].x(0);
        }
      } else {
        if (!this.dataScrolling.sens) {
          this.konvaObject.children[1].y(this.konvaObject.attrs.height - this.konvaObject.children[1].size().height);
          this.konvaObject.children[2].y(this.konvaObject.attrs.height - this.konvaObject.children[2].size().height);
        } else {
          this.konvaObject.children[1].y(0);
          this.konvaObject.children[2].y(0);
        }
      }
    }
  }

  options() {
    return ["RectPartial", "Scrolling"];
  }

  creationAnimation(konvaObject) {
    if (!(this.anim.isRunning() || this.anim2.isRunning())) {
      if (this.dataScrolling.axe) {
        if (!this.dataScrolling.sens) {
          this.scrollingHorizontal(konvaObject);
        } else {
          this.scrollingHorizontalReverse(konvaObject);
        }
      } else {
        if (!this.dataScrolling.sens) {
          this.scrollingVertical(konvaObject);
        } else {
          this.scrollingVerticalReverse(konvaObject);
        }
      }
    }
  }

  scrollingHorizontal(konvaObject) {
    const absoluteX = this.konvaObjectOption.width;
    const velocity = this.dataScrolling.speed;
    let firstText = konvaObject.children[1];
    let secondText = konvaObject.children[2];
    let posEnd = -firstText.size().width;
    let start = 0;

    firstText.x(absoluteX);
    secondText.x(absoluteX);

    if (absoluteX * 0.7 < firstText.size().width) {
      start = -(firstText.size().width - absoluteX * 0.3);
    }

    let animation = this.creationAnimX(firstText, secondText, absoluteX, posEnd, start, velocity, -1, false);

    animation.anim.start();
    this.anim = animation.anim;
    this.anim2 = animation.anim2;
  }

  scrollingVertical(konvaObject) {
    const absoluteY = this.konvaObjectOption.height;
    const velocity = this.dataScrolling.speed;
    let firstText = konvaObject.children[1];
    let secondText = konvaObject.children[2];
    let posEnd = -firstText.size().height;
    let start = 0;

    firstText.y(absoluteY);
    secondText.y(absoluteY);

    if (absoluteY * 0.7 < firstText.size().height) {
      start = -(firstText.size().height - absoluteY * 0.3);
    }

    let animation = this.creationAnimY(firstText, secondText, absoluteY, posEnd, start, velocity, -1, false);

    animation.anim.start();
    this.anim = animation.anim;
    this.anim2 = animation.anim2;
  }

  scrollingHorizontalReverse(konvaObject) {
    const absoluteX = this.konvaObjectOption.width;
    const velocity = this.dataScrolling.speed;
    let firstText = konvaObject.children[1];
    let secondText = konvaObject.children[2];
    let start = absoluteX - firstText.size().width;
    let posEnd = -firstText.size().width;

    firstText.x(-firstText.size().width);
    secondText.x(-secondText.size().width);

    if (absoluteX * 0.7 < firstText.size().width) {
      start = absoluteX * 0.7;
    }
    let animation = this.creationAnimX(firstText, secondText, posEnd, absoluteX, start, velocity, 1, true);

    animation.anim.start();
    this.anim = animation.anim;
    this.anim2 = animation.anim2;
  }

  scrollingVerticalReverse(konvaObject) {
    const absoluteY = this.konvaObjectOption.height;
    const velocity = this.dataScrolling.speed;
    let firstText = konvaObject.children[1];
    let secondText = konvaObject.children[2];
    let start = absoluteY - firstText.size().height;
    let posEnd = -firstText.size().height;

    firstText.y(-firstText.size().height);
    secondText.y(-secondText.size().height);

    if (absoluteY * 0.7 < firstText.size().height) {
      start = absoluteY * 0.7;
    }

    let animation = this.creationAnimY(firstText, secondText, posEnd, absoluteY, start, velocity, 1, true);

    animation.anim.start();
    this.anim = animation.anim;
    this.anim2 = animation.anim2;
  }

  creationAnimX(firstText, secondText, posStart, posEnd, start, velocity, sens = 1, reverse) {
    let end = true;
    const anim = new Konva.Animation(function (frame) {
      let dist = velocity * (frame.timeDiff / 1000) * sens;
      firstText.move({ x: dist, y: 0 });

      if (!reverse && firstText.x() <= posEnd) {
        reStart(firstText, anim, posStart);
      } else if (reverse && firstText.x() >= posEnd) {
        reStart(firstText, anim, posStart);
      }
      if (!reverse && firstText.x() <= start && end) {
        end = startSecond(anim2);
      } else if (reverse && firstText.x() >= start && end) {
        end = startSecond(anim2);
      }
      function reStart(firstText, anim, posStart) {
        firstText.x(posStart);
        anim.stop();
      }
      function startSecond(anim2) {
        anim2.start();
        return false;
      }
    });
    const anim2 = new Konva.Animation(function (frame) {
      let dist = velocity * (frame.timeDiff / 1000) * sens;
      secondText.move({ x: dist, y: 0 });

      if (!reverse && secondText.x() <= posEnd) {
        reStart(secondText, anim2, posStart);
      } else if (reverse && secondText.x() >= posEnd) {
        reStart(secondText, anim2, posStart);
      }
      if (!reverse && secondText.x() <= start && !end) {
        end = startFirst(anim);
      } else if (reverse && secondText.x() >= start && !end) {
        end = startFirst(anim);
      }
      function reStart(secondText, anim2, posStart) {
        secondText.x(posStart);
        anim2.stop();
      }
      function startFirst(anim) {
        anim.start();
        return true;
      }
    });
    let animation = { anim: anim, anim2: anim2 };
    return animation;
  }

  creationAnimY(firstText, secondText, posStart, posEnd, start, velocity, sens = 1, reverse) {
    let end = true;
    const anim = new Konva.Animation(function (frame) {
      let dist = velocity * (frame.timeDiff / 1000) * sens;
      firstText.move({ x: 0, y: dist });

      if (!reverse && firstText.y() <= posEnd) {
        reStart(firstText, anim, posStart);
      } else if (reverse && firstText.y() >= posEnd) {
        reStart(firstText, anim, posStart);
      }
      if (!reverse && firstText.y() <= start && end) {
        end = startSecond(anim2);
      } else if (reverse && firstText.y() >= start && end) {
        end = startSecond(anim2);
      }
      function reStart(firstText, anim, posStart) {
        firstText.y(posStart);
        anim.stop();
      }
      function startSecond(anim2) {
        anim2.start();
        return false;
      }
    });

    const anim2 = new Konva.Animation(function (frame) {
      let dist = velocity * (frame.timeDiff / 1000) * sens;
      secondText.move({ x: 0, y: dist });

      if (!reverse && secondText.y() <= posEnd) {
        reStart(secondText, anim2, posStart);
      } else if (reverse && secondText.y() >= posEnd) {
        reStart(secondText, anim2, posStart);
      }
      if (!reverse && secondText.y() <= start && !end) {
        end = startFirst(anim);
      } else if (reverse && secondText.y() >= start && !end) {
        end = startFirst(anim);
      }
      function reStart(secondText, anim2, posStart) {
        secondText.y(posStart);
        anim2.stop();
      }
      function startFirst(anim) {
        anim.start();
        return true;
      }
    });
    let animation = { anim: anim, anim2: anim2 };
    return animation;
  }

  // Setters
  setColor(val) {
    for (const child of this.konvaObject.children) {
      // Define fill attribute in each child with text
      if (child.attrs.name.includes("text") && child.attrs.text !== undefined) {
        child.setAttr("fill", val);
      }
    }
    return val;
  }

  setFont(val) {
    for (const child of this.konvaObject.children) {
      // Define fontFamily attribute in each child with text
      if (child.attrs.name.includes("text") && child.attrs.text !== undefined) {
        child.setAttr("fontFamily", val);
      }
    }
    return val;
  }

  setSize(val) {
    if (this.konvaObject.children.length > 2) {
      if (this.dataScrolling.axe) {
        this.konvaObject.children[0].setAttr("height", val);
      } else {
        // TODO: Need to resize width because width change in vertical mode
      }

      for (const child of this.konvaObject.children) {
        // Define fontSize attribute in each child with text
        if (child.attrs.name.includes("text") && child.attrs.text !== undefined) {
          child.setAttr("fontSize", val);
        }
      }
    }
    return val;
  }
}
